!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("PasswordRevealer", [], t) : "object" == typeof exports ? exports.PasswordRevealer = t() : e.PasswordRevealer = t();
}(this, function () {
  return function (e) {
    function t(o) {
      if (r[o]) return r[o].exports;
      var n = r[o] = {
        exports: {},
        id: o,
        loaded: !1
      };
      return e[o].call(n.exports, n, n.exports, t), n.loaded = !0, n.exports;
    }

    var r = {};
    return t.m = e, t.c = r, t.p = "", t(0);
  }([function (e, t) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e;
    },
        o = function o(e, t) {
      var o = {
        isRevealed: !1,
        trigger: {
          selector: ".PasswordRevealer-trigger",
          eventListener: "click"
        }
      };
      if (!e) throw new Error("Missing input argument");
      if ("string" == typeof e && (e = document.querySelector(e)), "INPUT" !== e.nodeName) throw new Error("First argument (input) must be an input element");
      "object" === ("undefined" == typeof t ? "undefined" : r(t)) ? (t = Object.assign({}, o, t), t.trigger = Object.assign(o.trigger, t.trigger)) : t = o;

      var n = t,
          i = n.isRevealed,
          s = function s() {
        e.type = "text", i = !0;
      },
          u = function u() {
        e.type = "password", i = !1;
      },
          f = function f() {
        i ? u() : s();
      };

      i && s();

      var c = function c() {
        var e = arguments.length <= 0 || void 0 === arguments[0] ? f : arguments[0],
            r = t.trigger,
            o = r.selector,
            n = r.eventListener,
            i = o;
        if ("string" == typeof o && (i = document.querySelector(o)), !i || !i.nodeType) throw new Error("Trigger must be a HTML element");
        i.addEventListener(n, e);
      };

      return {
        show: s,
        hide: u,
        toggle: f,
        init: c
      };
    };

    t["default"] = o, e.exports = t["default"];
  }]);
});